import { render, staticRenderFns } from "./configProperties.vue?vue&type=template&id=989640da&scoped=true&"
import script from "./configProperties.vue?vue&type=script&lang=js&"
export * from "./configProperties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "989640da",
  null
  
)

export default component.exports